<script setup lang="ts">
import { computed, inject, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../../stores";

interface ProfessionalBodyForm {
  name: string | null
  abbreviation: string | null
  profession: string | null
}

const store = useConfigurationsStore();
const successToast = inject<any>('successToast')
const errorToast = inject<any>('errorToast')

const form = ref<ProfessionalBodyForm>({
  name: null,
  abbreviation: null,
  profession: null
})
const spinner = ref(false)

const professionalBody = computed(() => store.professionalBody);
const insolvencyError = computed(() => store.insolvencyError);

const addBody = () => {
  spinner.value = true
  store.createProfessionalBody(form.value);
}

watch(professionalBody, () => {
  spinner.value = false
  store.fetchProfessionalBodies();
  successToast?.('Success', 'Professional Body created successfully')
})

watch(insolvencyError, () => {
  spinner.value = false
  errorToast?.('Error', 'An error occurred while creating professional body')
})
</script>

<template>
  <div class="p-4">
    <div class="space-y-4">
      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Name</label>
        <input
          type="text"
          v-model="form.name"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
          placeholder="e.g. Uganda Law Society"
          required
        />
      </div>

      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Abbreviation</label>
        <input
          type="text"
          v-model="form.abbreviation"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
          placeholder="e.g. ULS"
          required
        />
      </div>

      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Profession</label>
        <input
          type="text"
          v-model="form.profession"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
          placeholder="e.g. Lawyer"
          required
        />
      </div>

      <div class="flex justify-end gap-2">
        <button
          @click="addBody"
          :disabled="spinner"
          class="btn-primary"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</template>
